import { Matrix2D } from './utils';

declare let __NAME__: string, __VERSION__: string;
export const pkg_version = __VERSION__;
export const pkg_name = __NAME__;

export const DEFAULT_MATHS_KIT_STATE = {
  /** 元素的x坐标, 相对于container宽度的归一化数据 */
  x: 0.3,
  /** 元素的y坐标, 相对于container高度的归一化数据 */
  y: 0.5,
  /** 元素的宽度 */
  width: 400,
  /** 元素的矩阵, 用于计算元素的变换 */
  matrix: new Matrix2D().toArray(),
};